import React from 'react';
import { Col } from 'react-bootstrap';

import CSIO_logo from '../../../assets/images/CSIO_logo.png';
import downCarat from '../../../assets/images/downCarat.png';

const Title = () => {


  return (
      <Col>
        <h1 style={{ textAlign: 'center', marginTop: 200 }}>
          <img
            aria-label="CSIO"
            src={CSIO_logo}
            style={{
              width: '100%',
              height: 'auto',
              maxWidth: 400
            }}
          />
          <div style={{
            // font: 'normal normal normal 70px/49px',
            fontWeight: 'bold',
            fontSize: 63,
            fontFamily: "Montserrat SemiBold",
            letterSpacing: 7,
            color: '#12183A',
            textAlign: 'center'
          }}>
            2020
          </div>
          <div style={{
            // font: 'normal normal bold 45px/49px',
            fontWeight: 'bold',
            // lineHeight: 49,
            letterSpacing: 5.5,
            fontSize: 34,
            fontFamily: "Montserrat Bold",
            color: '#12183A',
            textAlign: 'center'
          }}>
            ANNUAL<br />REPORT
          </div>
        </h1>
        <div 
        className="quiver"
        style={{
          display: 'flex',
          justifyContent: 'center',
          paddingTop: 120
        }}>
          <img
          className="arrow"
            src={downCarat}
            height={24}
            width={48}
            alt=""
          />
        </div>
      </Col>
  )
}

export default Title;
